module.exports = __webpack_public_path__ + "img/GBwhatsapp-for-pc.e0566452.webp";